#import "@/apollo/fragments/Job.gql"
query CompletedJobs($limit: Int, $skip: Int) {
    completedJobs(limit: $limit, skip: $skip) {
        ...Job
        __typename
    }
}
